import groq from "groq"

export const groqVendorProjection = () => groq`
    "id": _id,
    title,
    status
`
